import React from "react";
import { SVG, IconProps } from "../SVG";

const DEFAULT_SIZE = 24;
export const CaretDown = ({ size = DEFAULT_SIZE, color = "#212121", ...props }: IconProps) => (
    <SVG
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        size={size}
        color={color}
        {...props}
    >
        <path
            fill="currentColor"
            d="M6.102 8c-1.074 0-1.648 1.265-.94 2.073l5.52 6.31a1.75 1.75 0 0 0 2.635 0l5.522-6.31c.707-.808.133-2.073-.941-2.073H6.102Z"
        />
    </SVG>
);
CaretDown.displayName = "CaretDown";
